import React from "react";
import { cn } from "utils/helpers";
import { Icon } from "assets/icons/Icon";

export const FileUploadDropzone = ({
	getRootProps,
	getInputProps,
	isDragAccept,
	isDragReject,
	isDragActive,
	selectedCategory,
	meta,
	inputRef,
	customMessage,
	types,
	maxFileSize,
	children,
	handleKeyDown,
	testId,
}) => (
	<section>
		<div
			{...getRootProps()}
			className={cn(
				"h-max w-full rounded-2xl border bg-white py-10 [text-align:-webkit-center]",
				isDragAccept && selectedCategory && "border-utility-brand-700",
				(isDragReject || (isDragActive && !selectedCategory)) &&
					"border-utility-error-500",
				meta.error && meta.touched && "border-red-400"
			)}
		>
			<div ref={inputRef}>
				<input
					{...getInputProps()}
					onClick={(e) => e.stopPropagation()}
					data-testid={testId}
				/>
			</div>
			<Icon
				icon="upload"
				className="icon-download"
			/>
			<p className="text-sm">
				<strong>{customMessage}</strong>
			</p>
			{children}
			<p className="text-sm">
				<button
					className="focusable font-semibold text-royal-blue"
					onKeyDown={handleKeyDown}
				>
					Click to upload
				</button>{" "}
				or drag and drop
			</p>
			<p className="text-xs">
				<span className="uppercase">
					{types.length > 0 && types.join(", ")}
				</span>
				{maxFileSize && ` (Max file size ${maxFileSize}MB)`}
			</p>
		</div>
	</section>
);
